import type { ReactNode, CSSProperties } from 'react'

export type BadgeVariant =
  | 'default'
  | 'gold'
  | 'silver'
  | 'bronze'
  | 'new'
  | 'rank'
  | 'win'
  | 'lose'
  | 'draw'
  | 'me'
  | 'soon'

export interface BadgeProps {
  children?: ReactNode
  variant?: BadgeVariant
  className?: string
  style?: CSSProperties
}

export function Badge({
  children,
  variant = 'default',
  className = '',
  style,
}: BadgeProps) {
  return (
    <span className={`badge badge--${variant} ${className}`.trim()} style={style}>
      {children}
    </span>
  )
}

export interface MedalBadgeProps {
  rank: number
}

export function MedalBadge({ rank }: MedalBadgeProps) {
  const shared: CSSProperties = { minWidth: 28, padding: '0 8px' }
  if (rank === 1) {
    return (
      <span className="badge badge--gold" style={shared}>
        {'🥇 1'}
      </span>
    )
  }
  if (rank === 2) {
    return (
      <span className="badge badge--silver" style={shared}>
        {'🥈 2'}
      </span>
    )
  }
  if (rank === 3) {
    return (
      <span className="badge badge--bronze" style={shared}>
        {'🥉 3'}
      </span>
    )
  }
  return (
    <span className="badge" style={shared}>
      {`#${rank}`}
    </span>
  )
}
